// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uMeZd{align-items:center;display:flex;gap:.5rem;justify-content:center}.WI7Tj{appearance:none;background:none;border:none;color:var(--sui-color-blue);cursor:pointer;line-height:1.1;padding:.125rem}.WI7Tj:hover{opacity:.7}.WI7Tj .lucide{font-size:1.4rem}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `uMeZd`,
	"trigger": `WI7Tj`
};
module.exports = ___CSS_LOADER_EXPORT___;
